import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { Option } from '@/components/inputs/AutocompleteInput';
import { GlobalButton } from '@/components';
import {
  SwapHoriz as TransitionIcon,
  ShoppingCartCheckout as OrdersIcon,
} from '@mui/icons-material';
import SummaryItem from './ScannerActions/SummaryItem';
import StatusBadge from './ScannerActions/StatusBadge';
import { MAX_SHIPPINGS_PER_BATCH } from '../../config/batchLimits';

interface ScannerActionsProps {
  transition: Option | null;
  count: number;
  onExecute: () => void;
  disabled: boolean;
}

const ScannerActions = ({
  transition,
  count,
  onExecute,
  disabled,
}: ScannerActionsProps) => {
  const isOverLimit = count > MAX_SHIPPINGS_PER_BATCH;
  const ready = count > 0 && !!transition && !isOverLimit;

  return (
    <div className='bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 p-6'>
      <div className='flex flex-col md:flex-row items-center justify-between gap-8'>
        <div className='flex items-center gap-10'>
          <SummaryItem
            label='Checkpoint seleccionado'
            icon={<TransitionIcon sx={{ fontSize: 18 }} />}
            value={
              transition?.label || (
                <span className='text-gray-300 italic'>No seleccionada</span>
              )
            }
          />

          <div className='h-10 w-px bg-gray-100' />

          <SummaryItem
            label='TOTAL'
            icon={<OrdersIcon sx={{ fontSize: 18 }} />}
            value={`${count} Pedido${count !== 1 ? 's' : ''}`}
          />
        </div>

        <div className='flex items-center gap-6'>
          <StatusBadge
            ready={ready}
            text={
              isOverLimit
                ? `Máximo ${MAX_SHIPPINGS_PER_BATCH} pedidos por tanda`
                : ready
                  ? 'Listo para aplicar'
                  : 'Pendiente de escaneo'
            }
          />

          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={onExecute}
            disabled={disabled || isOverLimit}
          >
            <TransitionIcon sx={{ mr: 1 }} />
            APLICAR CAMBIOS DE ESTADO
          </GlobalButton>
        </div>
      </div>
    </div>
  );
};

export default ScannerActions;
